import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import vClickOutside from 'v-click-outside'
import './registerServiceWorker';

Vue.config.productionTip = false;

Vue.prototype.$http = axios.create({
    baseURL: '/api/'
});

Vue.use(vClickOutside);

new Vue({
    router,
    vuetify,
    render: h => h(App),
    data: {
        messages: [],
        user: null
    },
    created() {
        let token = localStorage.getItem('token');
        if (token) {
            this.$http.defaults.headers.common['Authorization'] = `Token ${token}`;
        }
        this.$http.interceptors.response.use(null, (error) => {
            if (error.response.status === 403) {
                if (error.response.data.detail) {
                    // Timeout to make sure it shows on top of any other alert message.
                    setTimeout(() => {
                        this.$root.addMessage(error.response.data.detail, 'error');
                    }, 100);
                } else {
                    this.logout();
                }
            } else if (error.response.status === 400) {
                if (error.response.data.non_field_errors) {
                    // Timeout to make sure it shows on top of any other alert message.
                    setTimeout(() => {
                        this.$root.addMessage(error.response.data.non_field_errors[0], 'error');
                    }, 100);
                }
            }
            return Promise.reject(error);
        });

        setInterval(() => {
            this.messages = this.messages.filter(message => message.visible);
        }, 1000);
    },
    methods: {
        addMessage(message, type = 'info') {
            this.messages.push({
                key: Math.random().toString(36).substr(2, 5),
                message: message,
                visible: true,
                type: type
            });
        },
        logout() {
            localStorage.removeItem('token');
            delete this.$http.defaults.headers.common['Authorization'];
            this.user = null;
            this.$router.push({name: 'Login'});
        }
    }
}).$mount('#app');
